import { useState, useEffect } from "react";

export function useInView(ref, options = { threshold: 0.2 }) {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const current = ref.current;
    if (!current) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.unobserve(current);
      }
    }, options);

    observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, [ref, options]);

  return isInView;
}
